import { getRulesStore } from '../storage/stores';
import { getWeekdayValue, getHour, getSystemTimezone } from '../lib/dateTime';
import { TimeRestrictions } from '../types/api';
import { shouldCheckNavigation } from '../helper/rules';

export const isScheduleRestricted = (
  date: number,
  { shouldLog = false }: { shouldLog?: boolean } = {}
) => {
  const rulesStore = getRulesStore();
  const timeRestrictions = rulesStore.getTimeRestrictions();
  const timezone = rulesStore.getTimezone();

  if (
    !timeRestrictions ||
    !timezone ||
    !isScheduleRestrictedByRules(timeRestrictions, { shouldLog })
  ) {
    if (shouldLog) {
      console.log(
        `[isScheduleRestricted] false - No restrictions or schedule not enabled: timeRestrictionsExists=${!!timeRestrictions}, timezoneExists=${!!timezone}, isScheduleRestrictedByRules=${
          timeRestrictions
            ? isScheduleRestrictedByRules(timeRestrictions, { shouldLog })
            : false
        }`
      );
    }
    return false;
  }

  const dailySchedule = getWeekdayValue(
    timeRestrictions.time_ranges,
    date,
    timezone
  );

  const currentHour = getHour(date, timezone);
  const isRestricted = isHourRestricted(dailySchedule, currentHour, {
    shouldLog,
  });

  if (shouldLog) {
    console.log(
      `[isScheduleRestricted] ${isRestricted} - date=${date}, timezone=${timezone}, systemTimezone=${getSystemTimezone()} ,dailySchedule=${dailySchedule}, currentHour=${currentHour}`
    );
  }

  return isRestricted;
};

const isScheduleRestrictedByRules = (
  timeRestrictions: TimeRestrictions,
  { shouldLog = false }: { shouldLog?: boolean } = {}
): boolean => {
  const isEnabled = isScheduleRestrictionsEnabled(timeRestrictions, {
    shouldLog,
  });
  const shouldCheck = shouldCheckNavigation(timeRestrictions);
  const result = isEnabled && shouldCheck;

  if (shouldLog) {
    console.log(
      `[isScheduleRestrictedByRules] ${result} - isScheduleRestrictionsEnabled=${isEnabled}, shouldCheckNavigation=${shouldCheck}`
    );
  }

  return result;
};

const isScheduleRestrictionsEnabled = (
  timeRestrictions: TimeRestrictions,
  { shouldLog = false }: { shouldLog?: boolean } = {}
): boolean => {
  const result = timeRestrictions.is_daily_limit;

  if (shouldLog) {
    console.log(
      `[isScheduleRestrictionsEnabled] ${result} - is_daily_limit=${timeRestrictions.is_daily_limit}`
    );
  }

  return result;
};

const isHourRestricted = (
  dayHoursRules: number,
  hour: number,
  { shouldLog = false }: { shouldLog?: boolean } = {}
): boolean => {
  const hourMask = 1 << hour;
  const result = (dayHoursRules & hourMask) !== 0;

  if (shouldLog) {
    console.log(
      `[isHourRestricted] ${result} - dayHoursRules=${dayHoursRules}, hour=${hour}, hourMask=${hourMask}`
    );
  }

  return result;
};
